import React from 'react'
import { View, TouchableWithoutFeedback, Modal, Platform, Dimensions } from 'react-native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'

import PropTypes from 'prop-types'

import { VFText, VFButton, Icon } from '@vfgroup-oneplatform/foundation/Components'
import { getThemeImages, useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes'
import VFLottieView from '@vfgroup-oneplatform/foundation/Components/VFLottieView'

import { formatDate } from '../../Utils/DateHelpers'
import StoreInfo from '../StoreInfo'

import styles from './BookingSuccessModal.Styles'

import _Modal from 'react-native-modal'

const BookingSuccessModal = ({
  isVisible,
  onClose,
  service,
  store,
  date,
  isAddedToCalender,
  isAddToCalenderDisabled,
  formatAppointmentDate,
  onAddToCalenderPress,
  onAppointmentsPress,
  ...props
}) => {
  const theme = useTheme()
  const foundationImages = getThemeImages(theme.name)

  const insets = useSafeAreaInsets()

  if (Platform.OS === 'web' && Dimensions.get('window').width > 700) {
    return (
      <_Modal
        isVisible={isVisible}
        backdropOpacity={0.5}
        onSwipeComplete={onClose}
        onBackdropPress={onClose}
        propagateSwipe
        hideModalContentWhileAnimating
        hardwareAccelerated
        backdropTransitionOutTiming={0}
        style={{
          justifyContent: 'flex-end',
          margin: '0 !important',
          minWidth: 1920,
          maxWidth: 1920,
        }}
      >
        <View
          style={{
            minWidth: '600px',
            maxWidth: '600px',
            height: 'auto',
            backgroundColor: theme.colors.quickActionGradientColors.secondary,
            margin: 'auto',
            padding: '20px',
            paddingTop: null,
            borderRadius: "7px",
          }}
          onStartShouldSetResponder={() => true}>
          <TouchableWithoutFeedback onPress={onClose}>
            <View style={styles.closeButtonContainer(insets)}>
              <Icon name={foundationImages.TImages.ic_close.primary} size={25} />
            </View>
          </TouchableWithoutFeedback>

          <View style={styles.scrollViewContentContainStyle}>
            <View style={styles.contentStyle}>
              <VFLottieView
                type="tick"
                autoPlay
                loop={false}
                containerStyle={styles.lottieViewContainerStyle}
                lottieViewStyle={styles.lottieViewStyle}
              />

              <VFText i18nKey="book_appointment_confirm_title" style={styles.titleStyle(theme)} />

              <VFText
                i18nKey="book_appointment_confirm_subtitle"
                style={styles.subTitleStyle(theme)}
              />

              <VFText
                i18nKey={formatDate(date?.selectedDate, date?.selectedTime, formatAppointmentDate)}
                style={styles.dateTextStyle(theme)}
              />

              <StoreInfo
                {...(store || {})}
                containerStyle={styles.storeInfoContainerStyle(theme)}
                iconStyle={styles.storeInfoIconStyle}
              />
            </View>

            <View>
              {/* <VFButton
              type="secondary"
              title={
                isAddedToCalender
                  ? 'book_appointment_confirm_calendar_success_title'
                  : 'book_appointment_confirm_calendar_button_title'
              }
              onPress={() => onAddToCalenderPress({ service, store, date, ...props })}
              style={styles.addToCalanderButtonStyle}
              disabled={isAddToCalenderDisabled || isAddedToCalender}
              disabledStyle={styles.addToCalenderDisabledStyle(theme)}
              disabledTextStyle={styles.addToCalenderDisabledTextStyle(theme)}
            /> */}

              <VFButton
                title="book_appointment_confirm_appointment_button_title"
                onPress={onAppointmentsPress}
                style={styles.appointmentsButtonStyle}
              />
            </View>
          </View>
        </View>
      </_Modal>

    )
  }

  return (
    <Modal visible={isVisible}>
      <View style={styles.containerStyle(theme, insets)}>
        <TouchableWithoutFeedback onPress={onClose}>
          <View style={styles.closeButtonContainer(insets)}>
            <Icon name={foundationImages.TImages.ic_close.primary} size={25} />
          </View>
        </TouchableWithoutFeedback>

        <View style={styles.scrollViewContentContainStyle}>
          <View style={styles.contentStyle}>
            <VFLottieView
              type="tick"
              autoPlay
              loop={false}
              containerStyle={styles.lottieViewContainerStyle}
              lottieViewStyle={styles.lottieViewStyle}
            />

            <VFText i18nKey="book_appointment_confirm_title" style={styles.titleStyle(theme)} />

            <VFText
              i18nKey="book_appointment_confirm_subtitle"
              style={styles.subTitleStyle(theme)}
            />

            <VFText
              i18nKey={formatDate(date?.selectedDate, date?.selectedTime, formatAppointmentDate)}
              style={styles.dateTextStyle(theme)}
            />

            <StoreInfo
              {...(store || {})}
              containerStyle={styles.storeInfoContainerStyle(theme)}
              iconStyle={styles.storeInfoIconStyle}
            />
          </View>

          <View>
            {/* <VFButton
              type="secondary"
              title={
                isAddedToCalender
                  ? 'book_appointment_confirm_calendar_success_title'
                  : 'book_appointment_confirm_calendar_button_title'
              }
              onPress={() => onAddToCalenderPress({ service, store, date, ...props })}
              style={styles.addToCalanderButtonStyle}
              disabled={isAddToCalenderDisabled || isAddedToCalender}
              disabledStyle={styles.addToCalenderDisabledStyle(theme)}
              disabledTextStyle={styles.addToCalenderDisabledTextStyle(theme)}
            /> */}

            <VFButton
              title="book_appointment_confirm_appointment_button_title"
              onPress={onAppointmentsPress}
              style={styles.appointmentsButtonStyle}
            />
          </View>
        </View>
      </View>
    </Modal>
  )
}

BookingSuccessModal.propTypes = {
  isVisible: PropTypes.bool,
  isAddedToCalender: PropTypes.bool,
  isAddToCalenderDisabled: PropTypes.bool,
  service: PropTypes.shape({
    title: PropTypes.string.isRequired,
    image: PropTypes.shape({ uri: PropTypes.string }).isRequired,
  }),
  store: PropTypes.shape({
    name: PropTypes.string,
    address: PropTypes.shape({
      name: PropTypes.string,
    }),
    contactInfo: PropTypes.shape({
      email: PropTypes.string,
      phoneNumber: PropTypes.string,
    }),
  }),
  date: PropTypes.shape({
    selectedDate: PropTypes.string,
    selectedTime: PropTypes.string,
  }),
  formatAppointmentDate: PropTypes.func,
  onAppointmentsPress: PropTypes.func,
  onAddToCalenderPress: PropTypes.func,
  onClose: PropTypes.func,
}

export default BookingSuccessModal
